/**
 * @generated SignedSource<<275ddb0188165b6f6342baf12860a483>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsFooter_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
  readonly " $fragmentType": "PdpRespSimilarItemsFooter_user";
};
export type PdpRespSimilarItemsFooter_user$key = {
  readonly " $data"?: PdpRespSimilarItemsFooter_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsFooter_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsFooter_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1f48f572fba0d7a4547a23c81ca621dc";

export default node;
